import { FC } from 'react';
import { BoxProps, Box } from '@mui/material';


export const Image: FC<BoxProps<'img'>> = ({ sx, ...props }) => {
  return (
    <Box
      sx={[{ objectFit: 'cover' }, ...(Array.isArray(sx) ? sx : [sx])]}
      component="img"
      height="100%"
      width="100%"
      {...props}
    />
  );
};
